export const TENANT_STORAGE_KEY = 'selected_tenant_guids';

export const normalizeTenantGUIDs = (tenantGUIDs: string[]) => {
    return [...new Set(tenantGUIDs.filter(Boolean))];
};

export const getStoredTenantGUIDs = () => {
    const storedTenantGUIDs = localStorage.getItem(TENANT_STORAGE_KEY);
    if (storedTenantGUIDs) {
        try {
            const parsedTenantGUIDs = JSON.parse(storedTenantGUIDs);
            if (Array.isArray(parsedTenantGUIDs)) {
                return normalizeTenantGUIDs(
                    parsedTenantGUIDs.filter((guid): guid is string => typeof guid === 'string'),
                );
            }
        } catch {
            // Ignore malformed storage and fall back to an empty selection.
        }
    }

    return [];
};

export const setStoredTenantGUIDs = (tenantGUIDs: string[]) => {
    const normalizedTenantGUIDs = normalizeTenantGUIDs(tenantGUIDs);
    localStorage.setItem(TENANT_STORAGE_KEY, JSON.stringify(normalizedTenantGUIDs));
};
